import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  DwComponent, DwComponentType, DwConfigService, DwConfigServiceToken, DwEventService,
  DwExpressionService, DwMetaDataFormStateService, DwMetaDataRoutingService, DwMetaDataService,
  DwMetaDataServiceToken, DwSecurityUserService, DwUIMetaDataConfig, DwUIMetaDataConfigToken,
  DwUiConfigRegistryService
} from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../meta-data/app-meta-data.service';
import { AdminManagerService } from '../../../admin/services/admin-manager.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { PaymentsPricingRepositoryService } from '../../services/payments-pricing-repository.service';
import { PaymentsRepositoryService } from '../../services/payments-repository.service';
import { SubscriptionManagerService } from '../../services/subscription-manager.service';
import { SubscriptionSettingsComponent } from '../subscription-settings/subscription-settings.component';

@DwComponent({
  key: 'subscription-settings-redesign',
  name: 'Subscription Settings - Redesign',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.FlightSchool,
})
@Component({
  selector: 'app-subscription-settings-redesign',
  templateUrl: './subscription-settings-redesign.component.html',
  styleUrls: ['./subscription-settings-redesign.component.scss']
})
export class SubscriptionSettingsRedesignComponent extends SubscriptionSettingsComponent {
  activeTierName = '';

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    dwFormStateService: DwMetaDataFormStateService,
    dwSecurityUserService: DwSecurityUserService,
    dwEventService: DwEventService,
    dwMetaDataRoutingService: DwMetaDataRoutingService,
    paymentsRepositoryService: PaymentsRepositoryService,
    paymentPricingRespository: PaymentsPricingRepositoryService,
    dateTimeUtilService: DateTimeUtilService,
    adminManagerService: AdminManagerService,
    subscriptionManagerService: SubscriptionManagerService,
    http: HttpClient,
    @Inject(DwConfigServiceToken) configService: DwConfigService
  ) {
    super(
      dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService,
      dwFormStateService, dwSecurityUserService, dwEventService, dwMetaDataRoutingService,
      paymentsRepositoryService, paymentPricingRespository, dateTimeUtilService,
      adminManagerService, subscriptionManagerService, http, configService
    );
  }

  setupSubscriptTierDetails() {
    super.setupSubscriptTierDetails();
    const activeTier = this.subscriptionTierDetails.find(tier => tier.isActive);
    this.activeTierName = activeTier ? activeTier.subscriptionTier.SubscriptionTierName : '';
  }
}
